import React from 'react'
import classNames from 'classnames'

const svgClass = (className) => classNames(
  'svg-inline',
  className
)

const LogoIcon = ({ className }) => {
  return (
    <svg className={svgClass(className)} xmlns='http://www.w3.org/2000/svg' xmlSpace='preserve' viewBox='0 0 1000 1000'>
      <path
        fill='#009965'
        d='M999.96 499.58c0 276.14-223.86 500-500 500s-500-223.86-500-500 223.86-500 500-500 500 223.86 500 500z'
      />
      <path
        fill='#FFFFFF'
        d='m706.2 533.15-91.48-90.63c-5.69-5.64-13.15-8.46-20.61-8.46-7.46 0-14.92 2.82-20.61 8.46-18.93 18.76-44.1 29.09-70.88 29.09-55.27 0-100.23-44.55-100.23-99.3S447.36 273 502.63 273c26.77 0 51.94 10.33 70.88 29.09a29.318 29.318 0 0 0 20.61 8.46c7.73 0 15.14-3.04 20.61-8.46l91.48-90.63c11.38-11.28 11.38-29.56 0-40.83-54.38-53.87-126.67-83.54-203.57-83.54-158.74 0-287.89 127.95-287.89 285.22S343.9 657.53 502.64 657.53c76.9 0 149.2-29.67 203.57-83.54 11.37-11.28 11.37-29.57-.01-40.84z'
      />
      <path
        fill='#FFFFFF'
        d='m323.72 648.96 6.64 11.41 133.32 228.96c8.17 14.03 23.38 22.75 39.71 22.75 16.32 0 31.53-8.72 39.71-22.75l133.32-228.96 6.64-11.41c-49.08 39.68-111.59 63.47-179.67 63.47-68.08-.01-130.59-23.79-179.67-63.47z'
      />
    </svg>
  )
}

export default LogoIcon
